import React from "react";
import {Dialog} from "src/components/dialogs/Dialog"
import {styles} from "src/components/dialogs/ProjectDetailDialogStyle"
import { css } from "aphrodite-jss";
import { RequestState } from "src/models/RequestState";
import { ProjectDetail } from "src/models/ProjectDetail";
import { Api } from "src/core/api";
import axios from "axios";
import { JsonConvert } from "json2typescript";
import { Participant } from "src/models/Participant";
import { URLBuilder } from "src/core/URLBuilder";

interface IProjectDetailDialogProps {
    isOpen: boolean;
    onClose: any;
    id: string;
}


class ProjectDetailDialogState {
    public readonly requestState: RequestState;
    public readonly data: ProjectDetail;
    public readonly error: string;

    constructor() {
        this.requestState = RequestState.NOT_ASKED;
        this.data = new ProjectDetail;
        this.error = "";
    }

}

export class ProjectDetailDialog extends React.Component<IProjectDetailDialogProps, ProjectDetailDialogState> {

    constructor(props: IProjectDetailDialogProps){
        super(props);
        this.state = new ProjectDetailDialogState();
    }

    public async componentDidUpdate (prevProps: IProjectDetailDialogProps) {
        if(this.props.isOpen !== prevProps.isOpen  && this.props.isOpen === true) {
            //fetch the data
            const id = this.props.id;
            const url = URLBuilder.project_info(id)
            axios.get(url).then((res)=> {
                if(res.status === 200){
                    try{
                        console.log(res.data)
                        const jsonConvert = new JsonConvert();
                        const projectDetail = jsonConvert.deserialize(res.data, ProjectDetail);
                        const newState = {...this.state, requestState: RequestState.SUCCESS, data: projectDetail}
                        this.setState(newState)
                    }catch(error) {
                        const newState = {...this.state, requestState: RequestState.ERROR, error: error.toString()}
                        this.setState(newState)
                    }
                }else{
                    const error = res.statusText + ":" + res.data
                    const newState = {...this.state, requestState: RequestState.ERROR, error: error}
                    this.setState(newState)
                }    
            }).catch((err)=>{
                const error = err.toString();
                const newState = {...this.state, requestState: RequestState.ERROR, error: error}
                this.setState(newState)
            });
        }
    }

    public render() { 
        
        let content;

        if(this.props.isOpen){
            if(this.state.requestState === RequestState.SUCCESS){
                content = (
                    <div id="content" className={css(styles.content)} >
                        <a id="name" href={`/project/${this.state.data.id}`} className={css(styles.name)}  >
                            {this.state.data.name}
                        </a>
                        <div id="description" className={css(styles.description)}  >
                            {this.state.data.description}
                        </div>
                        <div id="participants_container" className={css(styles.participants)} >
                            <div id="label" className={css(styles.participantsLabel)} >
                                Partipants: 
                            </div>
                            <div id="participants" className={css(styles.participants)} >
                                {this.state.data.participants.map(this.buildParticipant)}
                            </div>
                        </div>
                    </div>
                );
            }else if(this.state.requestState === RequestState.ERROR){
                content = (
                    <div>
                        {this.state.error}
                    </div>
                );
            }else if(this.state.requestState === RequestState.LOADING){
                content = (
                    <div>
                        Loading
                    </div>
                );
            }else{
                content = (<div>

                </div>);
            }
        }else{
            content = (
                <div>

                </div>
            );
        }   
        
        return (<Dialog isOpen={this.props.isOpen} onClose={this.props.onClose} > 
            <div id="container" className={css(styles.container)}>
                <React.Fragment>
                    {content}
                </React.Fragment>
            </div>
        </Dialog>);
    }

    private buildParticipant = (participant: Participant, index: number) => {
        
        let content;

        let seperator;

        if(index !== this.state.data.participants.length - 1){
            seperator = ","    
        }else{
            seperator = ""
        }

        if(participant.ud_flag){
            content = (
                <a href={`/faculty/${participant.id}`} >
                    {participant.first_name + " " + participant.last_name + seperator} &nbsp;
                </a>
            )
        }else{
            content = (
                <div>
                    {participant.first_name + " " + participant.last_name + seperator } &nbsp;
                </div>
            );
        }

        return (
            <div key={index} >
                {content}
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/dialogs/ProjectDetailDialog.tsx